import { z } from 'zod';
import { countryIsoSchema, currencyIsoSchema, idSchema, softDelete, timestamps } from './utility';
import { userSchema } from './user';
import { clientSchema } from './client';
import { productSchema } from './product';
import { partnerSchema } from './partner';
import { claimSchema } from './claim';
import { debtorSchema } from './debtor';
import { transitionLogSchema } from './transition-log';
import { legalRelationshipSchema } from './schemas';
import { paymentSchema } from './payment';

export const caseSchema = z.object({
  id: idSchema,
  uuid: z.string(),
  payee_case_reference_id: z.string(),
  user_id: idSchema,
  user: userSchema,
  client_id: idSchema,
  client: clientSchema,
  product_id: idSchema,
  product: productSchema,
  partner_id: idSchema,
  partner: partnerSchema,
  parent_id: idSchema.nullable(),
  ref_id: z.string().nullable(),
  country_iso: countryIsoSchema,
  currency_iso: currencyIsoSchema,
  description: z.string().nullable(),
  state: z.string(),
  case_data: z.unknown().nullable(),
  tone_of_voice: z.enum(['formal', 'informal']).nullable(),
  is_common_cost_balance: z.boolean(),
  legal_relationship_id: idSchema.nullable(),
  legalRelationship: legalRelationshipSchema,
  legal_relationship_specification: z.string().nullable(),
  legal_relationship_explanation: z.string().nullable(),
  legal_relationship_date_at: z.string().nullable(),
  started_at: z.string().nullable(),
  closed_at: z.string().nullable(),
  ...timestamps,
  ...softDelete,

  users: z.array(userSchema),
  claims: z.array(claimSchema),
  debtors: z.array(debtorSchema),
  transitionLogs: z.array(transitionLogSchema),
  payments: z.array(paymentSchema),
});

export type Case = z.infer<typeof caseSchema>;